import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  TemplateRef,
  EventEmitter,
  SimpleChanges,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  AfterViewInit,
  OnDestroy,
  Optional,
  Inject,
} from '@angular/core';
import { TableConfig } from '../../entities/table-config';
import { fromEvent, Observable, iif } from 'rxjs';
import { HttpService } from '../../services/http/http-service.service';
import { CommonService } from '../../services/common/common.service';
import { STableService } from './s-table.service';
import { NzModalService, NzMessageService, NzCheckboxGroupComponent } from 'ng-zorro-antd';
import $ from 'jquery';
import { testData } from './imulated';
import { cloneDeep } from 'lodash';
import { SCheckboxGroupComponent } from '../s-checkbox-group/s-checkbox-group.component';
import { XhrFactory } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { TABLE_CONFIG, TableConfig as TConfig } from '../../config/config';
@Component({
  selector: 'app-s-table',
  templateUrl: './s-table.component.html',
  styleUrls: ['./s-table.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class STableComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @Input() cellContent: TemplateRef<any>;
  @Input() tableConfig: TableConfig;
  @Output() radioCheckd: EventEmitter<any> = new EventEmitter(); // 单选选中项
  @Output() comChecked: EventEmitter<any> = new EventEmitter(); // 多选选中项
  @Output() rowData: EventEmitter<any> = new EventEmitter();  // 行数据
  @Output() editRowTable: EventEmitter<any> = new EventEmitter(); // 编辑单元格数据
  @Output() getRowData: EventEmitter<any> = new EventEmitter(); // 编辑单元格数据

  @Input()
  checkObj: any = {};

  @Input()
  checkKey = 'id';
  checkedArrData: any = [];

  allChecked = false;
  allUnChecked = true;
  indeterminate = false;
  pageRecords: any[] = []; // 表格数据
  loadingCount = 0; // 加载状态
  scroll: any = { x: '100%', y: '100%' }; // 表格滚动参数
  fixedItem: any = '80px'; // 固定项宽度,选项、单选、多选
  pageData: any = { page: 1, pageSize: 10, total: 0 };
  params: any = {};
  tableData: any;
  right = false;
  columns: any = [];
  baseColumns: any[];
  searchItemsInited = false;
  tableHeight: any = '';
  tabStyle: any = {
    height: ''
  };
  // 未显示的列数据
  collapseOptions: any = {
    mode: 'multiple',
    label: '请选择要显示的列',
    data: [],
    width: '300px',
    modelChange: (e) => {
      this.showCols(e);
    }
  };
  mapperList: any = [];
  /** -------------编辑单元格--------------- */
  listOfData: any = [];

  // 所有请求过来的历史数据
  @Input()
  totalHistoryList: Array<any> = [];

  /**
   * 获取列表的接口方法
   * 某些业务系统页面请求转换Text有问题
   */
  @Input()
  httpMethodType: 'httpGetText' | 'httpGet' = 'httpGetText';

  visible = false;
  collapseCheckedMap: any = {};

  constructor(
    private httpService: HttpService,
    private commonService: CommonService,
    private tableService: STableService,
    private modal: NzModalService,
    private message: NzMessageService,
    private changeDetectorRef: ChangeDetectorRef,
    @Optional() @Inject(TABLE_CONFIG) private TABLE_CONFIG?: TConfig,
  ) { }


  public get loading(): boolean {
    return this.loadingCount > 0;
  }

  ngOnDestroy(): void {
    this.collapseOptions.data = [];
    this.pageRecords = [];
    this.columns = [];
    this.checkObj = {};
    this.listOfData = [];

  }
  ngAfterViewInit(): void {
    this.setScrollY();
  }

  ngOnInit(): void {
  }

  changeStatus(key) {
    this.tableConfig[key] = true;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.tableConfig) {
      this.changesLoadTable(changes);
    }
    if (changes.checkObj) {
      this.refreshStatus();
    }
  }

  change() {
    this.visible = !this.visible;
  }

  collapseChange(e: Array<any>) {
    this.collapseCheckedMap = e.reduce((pre, cur) => {
      pre[cur.value] = true;
      return pre;
    }, {});
    this.showCols(e);
  }

  changesLoadTable(changes: SimpleChanges) {
    if (!changes.tableConfig.currentValue) {
      return;
    }
    this.tableConfig = changes.tableConfig.currentValue;
    if (this.tableConfig.reLoad) {
      this.reload();
    } else {
      // 设置表格初始数据的active、checked、disabled属性
      // 设置表格滚动高度
      this.pageData.page = this.tableConfig.page;
      this.pageData.pageSize = this.tableConfig.pageSize;
      this.setScrollY();
      this.columns = [];
      this.pageRecords = [];
      this.listOfData = [];
      // 处理静态表头数据
      if (this.tableConfig.columns) {
        this.columns = [...this.tableConfig.columns];
        this.addOperationItem();
        this.initTableWidth();
        this.initSearchItems();
        if (!this.listOfData.length) {
          this.setEditData();
        }
        this.getTableData();
      } else {
        // 获取动态表头数据
        this.getDynamicHeaders();
      }
      // 可编辑行表格
      if (this.tableConfig.isEditCol) {
        if (this.tableConfig.tableData) {
          this.listOfData = this.tableConfig.tableData || [];
        }
        //  else {
        //   this.getEditTableData();
        // }
        // else {
        //   this.initListOfData(this.testData);
        //   // this.listOfData = this.testData;
        //   // console.log('listOfDatra', this.listOfData);
        //   // this.getEditTableData();
        // }
      }
      // if (this.tableConfig.tableData) {
      //   this.pageRecords = this.tableConfig.tableData || [];
      //   if (this.tableConfig.isPage) {
      //     this.pageData.total = this.pageRecords.length;
      //   }
      //   this.initTableWidth();
      // } else {
      //   this.getDynamicTableData();
      // }
      this.windResize();
    }
  }
  async getDynamicHeaders() {
    if (this.tableConfig.queryTitle) {
      if (this.tableConfig.titleParams) {
        this.loadingCount++;
        this.columns = [];
        const res = await this.httpService.httpGet(this.tableConfig.queryTitle, this.tableConfig.titleParams).pipe(
          finalize(() => this.loadingCount--)
        ).toPromise();
        if (res.code === 1) {
          if (res.data.mapperList && res.data.mapperList.length) {
            this.initDynamicHeaders(res.data.mapperList);
          }
        }
      }
    }
  }
  initDynamicHeaders(mapperList) {
    this.setColumnsFormat(mapperList);
    this.initTableWidth();
    this.initSearchItems();
    this.setEditData();
    this.getTableData();
    this.changeDetectorRef.detectChanges();
  }

  getTableData() {
    if (this.tableConfig.tableData) {
      this.pageRecords = this.tableConfig.tableData;
      if (this.tableConfig.isPage) {
        this.pageData.total = this.pageRecords.length;
      }
      this.initTableWidth();
    } else {
      this.getDynamicTableData();
    }
  }

  setEditData() {
    if (this.tableConfig.isEditCol) {
      if (!this.tableConfig.tableData) {
        this.initEditData(testData);
      }
    }
  }

  initEditData(data) {
    for (let i = 0; i < data.length; i++) {
      this.listOfData = [...this.listOfData, this.initRow(data[i])];
      this.tableConfig.tableData = this.listOfData;
    }
  }
  async getDynamicTableData() {
    this.loadingCount++;
    this.pageRecords = [];
    if (this.tableConfig.queryTable) {
      if (this.tableConfig.defaultLoad) {
        this.initHttpTableParams();
        /** 暂时未提供接口 */
        const res = await this.httpService[this.httpMethodType](this.tableConfig.queryTable, this.params).pipe(
          finalize(() => this.loadingCount--)
        ).toPromise();
        if (res.code === 1) {
          const { data, totalCount: total, page, pageSize } = res.data;
          this.pageData = {
            total,
            page,
            pageSize,
          };
          this.setAttributes();
          this.pageRecords = data;
          // tslint:disable-next-line:max-line-length
          this.totalHistoryList.push(
            ...this.pageRecords.filter(i =>
              this.totalHistoryList.every(x =>
                x[this.checkKey] !== i[this.checkKey]
              )
            )
          );
          this.refreshStatus();
          this.changeDetectorRef.detectChanges();
        }
      }
    }
  }

  async getEditTableData() {
    if (this.tableConfig.queryTable) {
      if (this.tableConfig.defaultLoad) {
        setTimeout(() => {
          this.loadingCount++;
        });
        const res = await this.httpService.httpGet(this.tableConfig.queryTable, this.tableConfig.tableParams).pipe(
          finalize(() => this.loadingCount--)
        ).toPromise();
        if (res.code === 1) {
          if (res.data.mapperList && res.data.mapperList.length) {
            this.initEditTableData(res.data.mapperList);
          }
        }
      }
    }
  }

  // 可参考baseServic 的initRowData方法
  initEditTableData(mapperList) {
    this.listOfData = [];
    for (let i = 0; i < mapperList.length; i++) {
      this.listOfData.push(this.initRow());
      for (const key in mapperList[i]) {
        if (mapperList[i].hasOwnProperty(key)) {
          this.listOfData[i].forEach((item) => {
            if (!item.others) {
              if (item.name === key) {
                item.value = mapperList[i][key];
              }
              if (key === 'showFormatter') {
                for (const fk in mapperList[i][key]) {
                  if (item.name === fk) {
                    item.value = mapperList[i][key][fk];
                  }
                }
              }
            } else {
              if (item.name === key) {
                item.others.value = mapperList[i][key];
              }
              if (key === 'showFormatter') {
                for (const fk in mapperList[i][key]) {
                  if (item.name === fk) {
                    item.others.value = mapperList[i][key][fk];
                  }
                }
              }
            }
          });
        }
      }
    }
    // console.log('listOfData', this.listOfData);
  }
  /** 设置动态表头，包括扩展属性 */
  setColumnsFormat(mapperList) {
    if (this.collapseOptions.data.length === 0) {
      mapperList.forEach((item, index) => {
        if (item.showFormatter) {
          const temp = {
            header: item.showFormatter.showName, name: item.propertyName,
            attrs: {
              description: item.showFormatter.description, width: item.showFormatter.colSpanWidth,
              type: item.showFormatter.colUiType.split(',')[1], colSerach: item.showFormatter.colSerach
            }
          };
          for (const key in item.showFormatter) {
            if (item.showFormatter[key] === 'true' || item.showFormatter[key] === 'false') {
              setTimeout(() => {
                temp.attrs[key] = JSON.parse(item.showFormatter[key]);
              });
            }
          }
          if (temp.attrs.type === 'date') {
            const others = {
              ui: {
                type: 'date'
              },
              type: 'date',
              placeHolder: '请选择日期',
              showTime: false
            };
            Object.defineProperty(temp, 'others', { value: others, enumerable: true });
          }
          if (temp.attrs.type === 'year') {
            const yearOthers = {
              ui: {
                type: 'year'
              },
              type: 'year',
              placeHolder: '请选择年份'
            };
            Object.defineProperty(temp, 'others', { value: yearOthers, enumerable: true });
          }
          const isCollapse = JSON.parse(item.showFormatter.collapse);
          if (isCollapse) {
            this.columns.push(temp);
          } else {
            const optionTemp = {
              label: item.showFormatter.showName, value: item.propertyName, notSearch: true,
              name: item.propertyName, header: item.showFormatter.showName, attrs: {}
            };
            for (const key in item) {
              if (item.hasOwnProperty(key)) {
                if (key === 'showFormatter') {
                  optionTemp.attrs = temp.attrs;
                }
              }
            }
            this.collapseOptions.data.push(optionTemp);
          }
        }
      });
      this.addOperationItem();
      this.baseColumns = [...this.columns];
    } else {
      const tempColumns = JSON.parse(JSON.stringify(this.baseColumns));
      const oper = tempColumns.pop();
      this.collapseOptions.data.forEach((item) => {
        if (item.active) {
          tempColumns.push(item);
        }
      });
      tempColumns.push(oper);
      this.columns = tempColumns;
      this.initTableWidth();
    }
  }

  // 将列搜索项配置整合到columns中
  initSearchItems() {
    if (!this.columns.length) { return; }
    // 默认为文本框和数字框适配搜索项
    this.columns.forEach((f) => {
      if (f.attrs.colSerach) {
        f.attrs.colSerach = JSON.parse(f.attrs.colSerach);
      }
      if (f.attrs.colSerach) {
        const temp = cloneDeep(f);
        const searchItem: any = {
          name: temp.name, type: temp.attrs.type,
          config: { placeHolder: `请输入${temp.header}`, value: '', type: temp.attrs.type }
        };
        // if (!this.tableConfig.colSearchConfig || this.tableConfig.colSearchConfig.length === 0) { return; }
        this.tableConfig.colSearchConfig.forEach((col) => {
          if (col.colName === temp.name) {
            if (temp.attrs.type === 'treeSelect' || temp.attrs.type === 'select') {
              searchItem.config.width = `${parseInt(temp.attrs.width, 0) - 30}px`;
              searchItem.config.url = col.config.url;
              searchItem.config.placeHolder = `请选择${temp.header}`;
              searchItem.name = col.name;
              if (temp.attrs.type === 'select') {
                searchItem.config.defaultLoad = true;
              }
            }
            searchItem.config = { ...searchItem.config, keys: col.config.keys };
          }
        });
        f.searchItem = searchItem;
      }
    });
    this.searchItemsInited = true;
  }

  // 不固定列的选中与取消
  showCols(e) {
    this.collapseOptions.data.forEach((f) => {
      f.active = false;
    });
    if (e.length > 0) {
      e.forEach((item) => {
        item.active = true;
      });
    }
    const tempColumns = JSON.parse(JSON.stringify(this.baseColumns));
    let arr = [];
    const oper = tempColumns[tempColumns.length - 1];

    if (oper.attrs.isOperation) {
      tempColumns.pop();
    }
    arr = tempColumns.concat(e);
    if (oper.attrs.isOperation) {
      arr.push(oper);
    }
    this.columns = arr;
    this.initTableWidth();
  }
  setScrollY() {
    this.scroll.y = '100%';
    if ((this.TABLE_CONFIG && this.TABLE_CONFIG.scrollY) || this.tableConfig.scrollY) {
      this.scroll.y = (this.tableConfig.scrollY || this.TABLE_CONFIG.scrollY) + 'px';
      // this.tableHeight = this.scroll.y + 100 + 'px';
      // this.tabStyle.height = this.tableHeight;
    } else {
      // 计算表格所占高度
      let pageHeight = 0;
      const windowHeight = document.body.clientHeight;
      // const tabsHeight = parseInt(sessionStorage.getItem('tabsHeight'), 0);
      const tabsHeight = 40;
      let topBarHeight = 0;
      if (document.getElementById('stOperationBar')) {
        topBarHeight = document.getElementById('stOperationBar').clientHeight;
      }
      const headerHeight = 63;
      // const headerHeight = parseInt(sessionStorage.getItem('headerHeight'), 0) || 65;
      if (this.tableConfig.isPage) {
        // pageHeight = parseInt(sessionStorage.getItem('pageHeight'), 0);
        pageHeight = 60;
      }
      const resultHeight = windowHeight - (headerHeight + tabsHeight + topBarHeight + pageHeight);
      this.scroll.y = `${resultHeight - 230}px`;
      this.tableHeight = `${resultHeight}px`;
      this.tabStyle.height = this.tableHeight;
      $('ant-table-content>.ant-table-scroll>.ant-table-body').height(this.scroll.y + '!important');
      $('.ant-table-content>.ant-table-scroll>.ant-table-body').css({ overflow: 'auto' });
      // $('.ant-table-placeholder').css({ position: 'absolute', width: '100%', top: '20%' });
      $('.ant-table-body.ng-star-inserted').height(`${resultHeight - 20}px !important`);
      // $('.ant-table-body.ng-star-inserted').attr('maxHeight', `${resultHeight - 20}px !important`);
      $('.ant-table-body.ng-star-inserted').css('height', `${resultHeight - 20}px !important`);
    }
  }

  // 与initRow类似，暂时保留
  initItemData() {
    const arr = {};
    this.columns.forEach((item) => {
      const temp = {
        name: item.name,
        type: '',
        value: null,
        edit: true,
        error: false,
        others: null,
        isSort: false,
        isLeft: false,
        isRight: false
      };
      if (item.attrs) {
        const tempAttrs = JSON.parse(JSON.stringify(item.attrs));
        setTimeout(() => {
          temp.isSort = tempAttrs.isSort;
          temp.isLeft = tempAttrs.isLeft;
          temp.isRight = tempAttrs.isRight;
        });
        temp.type = tempAttrs.type;
        if (!tempAttrs.type || tempAttrs.type === 'string') {
          temp.type = 'string';
          temp.value = tempAttrs.value || '';
        }
        if (tempAttrs.type === 'checkBox') {
          temp.type = 'checkBox';
          temp.value = false;
        }
        if (tempAttrs.type === 'float') {
          temp.type = 'float';
          temp.value = 0.0;
        }
      }
      if (item.others) {
        const tempOthers = JSON.parse(JSON.stringify(item.others));
        if (tempOthers.type === 'date') {
        } else if (tempOthers.type === 'select') {
          tempOthers.defaultLoad = true;
          Object.defineProperty(tempOthers, 'width', { value: '100%', enumerable: true });
        }
        temp.others = tempOthers;
      }
      setTimeout(() => {
        arr[temp.name] = temp;
      });
    });
    return arr;
  }

  /**
   * 页码改变
   */
  // pageIndexChange(e) {
  //   this.pageData.page = e;
  //   this.initHttpTableParams();
  //   this.getDynamicTableData();
  // }

  /**
   * 分页条数改变
   */
  // pageSizeChange(e) {
  //   this.pageData.pageSize = e;
  //   this.initHttpTableParams();
  //   this.getDynamicTableData();
  // }
  getParams(e) {
    const { pageIndex, pageSize } = e;
    const { page, pageSize: size } = this.pageData;
    // tslint:disable-next-line:triple-equals
    if (page == pageIndex && pageSize == size) {
      return;
    }
    this.pageData.page = e.pageIndex;
    this.pageData.pageSize = e.pageSize;
    this.initHttpTableParams();
    this.getDynamicTableData();
  }
  /**
   * 排序
   */
  sort(key, e) {
    // console.log('key', key);
    // console.log('e', e);
    // e:descend   降序
    // e:ascend  升序
    // 请求数据
  }

  sortId(a, b, key) {
    return a.key - b.key;
  }

  /**
   * 初始化表格请求参数
   */
  initHttpTableParams() {
    let params: any = {
      order: 'creationTime desc'
    };
    if (this.tableConfig.isPage) {
      params = {
        ...params,
        pageSize: this.pageData.pageSize,
        page: this.pageData.page,
      };
    }
    Object.assign(params, this.tableConfig.tableParams);

    /*
     * tableParams里面的page和pageSize只使用一次
     */
    delete this.tableConfig.tableParams.page;
    delete this.tableConfig.tableParams.pageSize;
    // if (this.tableConfig.tableParams && Object.keys(this.tableConfig.tableParams).length) {
    //   for (const key in this.tableConfig.tableParams) {
    //     if (this.tableConfig.tableParams.hasOwnProperty(key)) {
    //       if (typeof this.tableConfig.tableParams[key] !== 'number' && this.tableConfig.tableParams[key] !== null &&
    //         this.tableConfig.tableParams[key] !== undefined && this.tableConfig.tableParams[key] !== '') {
    //         Object.defineProperty(params, key, {
    //           value: this.tableConfig.tableParams[key],
    //           enumerable: true,
    //         });
    //       }
    //     }
    //   }
    // }
    this.params = params;

  }

  concatParams(params) {
    let result = '';
    for (const item in params) {
      if (params.hasOwnProperty(item)) {
        if (params[item] && String(params[item])) {
          result += `&${item}=${params[item]}`;
        }
        if (result) {
          result = '?' + result.slice(1);
        }
      }
    }
    return result;
  }

  /**
   * 组件内部自定义内容
   */
  outCellContext(data, value, record, index) {
    return {
      $implicit: data,
      value,
      record,
      index
    };
  }

  /**
   * 计算表格所占宽度
   */
  initTableWidth() {
    let sum = 0;
    const reg = new RegExp('px', 'g');
    let clientWidth = document.body.clientWidth;
    if (this.tableConfig.width) {
      clientWidth = this.tableConfig.width;
    }
    if (
      this.tableConfig.radioCheck ||
      this.tableConfig.comCheck ||
      this.tableConfig.showRowNum
    ) {
      sum = 60;
    }
    this.columns.forEach((item) => {
      let width: any = item.attrs.width;
      if (typeof width === 'string') {
        if (width.indexOf('px') === -1) {
          sum += parseInt(width, 0);
          item.attrs.width = `${item.attrs.width}px`;
        } else {
          width = width.toString().replace(reg, '');
          sum += parseInt(width, 0);
        }
      }
    });
    if (clientWidth < sum + 20) {
      this.scroll.x = `${sum + 20}px`;
    } else {
      this.scroll.x = '100%';
    }
    this.changeDetectorRef.detectChanges();
  }

  windResize() {
    fromEvent(window, 'resize').subscribe((e) => {
      if (e.isTrusted) {
        this.initTableWidth();
        this.setScrollY();
      }
    });
  }

  /**
   * 初始化表格数据选中状态
   */
  setAttributes() {
    this.pageRecords.forEach((item) => {
      Object.defineProperties(item, {
        checked: { value: false, enumerable: true, writable: true },
        active: { value: false, enumerable: true, writable: true },
        disabled: { value: true, enumerable: true, writable: true },
      });
    });
  }
  addOperationItem() {
    if (this.tableConfig.isOperation) {
      let oWidth = '200';
      if (this.tableConfig.operationWidth) {
        oWidth = this.tableConfig.operationWidth;
      }
      this.tableConfig.operationObj = {
        name: 'operation', header: '操作', attrs: {
          width: oWidth, isTemplete: true, isOperation: true, isRight: true
        }
      };
      this.columns.push(this.tableConfig.operationObj);
    }
  }

  rowClick(data) {
    // this.pageRecords.forEach((item, index) => {
    //   if (this.tableConfig.radioCheck) {
    //     item.active = item.checked = false;
    //     if (index === i) {
    //       item.active = item.checked = true;
    //       this.radioCheckd.emit(item);
    //       this.rowData.emit(item);
    //     }
    //   } else if (this.tableConfig.comCheck) {
    //     if (index === i) {
    //       item.active = !item.active;
    //       item.checked = !item.checked;
    //       const mutilArr: any = this.pageRecords.filter((m) => !m.disabled && m.checked);
    //       // console.log('多选选中行', mutilArr);
    //       // this.rowData.emit(mutilArr);
    //       // this.comChecked.emit(mutilArr);
    //       this.refreshStatus();
    //     }
    //   }
    // });
    this.pageRecords.forEach((res) => {
      if (!res.disabled) {
        res.active = false;
      }
    });
    data.active = true;
    this.getRowData.emit(data);
  }

  /**
   * 选中所有行
   */
  checkAll(checked) {
    this.pageRecords.forEach((data) => {
      if (!data.disabled) {
        this.checkObj[data[this.checkKey]] = data.active = checked;
      }
    });
    const list = this.totalHistoryList.filter(
      (item) => !item.disabled && this.checkObj[item[this.checkKey]]
    );
    this.comChecked.emit(list);
    this.refreshStatus();
  }

  /**
   * 选中单行,可多选
   */
  checkListData(i, checked): void {
    //
    // if (data.checked) {
    //   this.checkedArrData.push(data.id);
    // }
    this.pageRecords[i].active = this.checkObj[i[this.checkKey]];
    this.refreshStatus();
    const checkListData = this.totalHistoryList.filter(
      (item) => !item.disabled && this.checkObj[item[this.checkKey]]
    );
    //
    // console.log('多选选中复选框', checkListData);
    this.comChecked.emit(checkListData);
  }

  /**
   * 选中单行，只能单选
   */
  singleCheck(i: number) {
    this.pageRecords.forEach((item, index) => {
      if (i === index) {
        item.active = item.checked = !item.active;
        if ((item.checked === true)) {
          // console.log('单选，选中复选框', item);
          this.radioCheckd.emit(item);
        }
      } else {
        item.active = false;
        item.checked = false;
      }
    });
  }

  refreshStatus(): void {
    if (this.pageRecords.length === 0) {
      return;
    }
    const validData = this.pageRecords.filter((value) => !value.disabled);
    const allChecked =
      validData.length > 0 &&
      validData.every(item => this.checkObj[item[this.checkKey]]);
    this.allUnChecked = validData.every(item => !this.checkObj[item[this.checkKey]]);
    this.allChecked = allChecked;
    this.indeterminate = !allChecked && !this.allUnChecked;
  }

  /** --------------------编辑单元格----------------------- */

  addEditRow() {
    this.addRow();
  }

  stopEdit(e: any) {
    // e.edit = false;
    // if (!e.type || e.type === 'string') {
    //   if (!e.value) {
    //     // e.error = true;
    //     e.edit = true;
    //   } else {
    //     // e.error = false;
    //     e.edit = false;
    //   }
    // }
    // else if (e.type && e.type !== 'string'){
    //   if (e.value === 0) {
    //     e.error = true;
    //     e.edit = true;
    //   } else {
    //     e.error = false;
    //     e.edit = false;
    //   }
    // }
  }

  startEdit(e: any) {
    // if (!e.type || e.type === 'string') {
    //   if (!e.value) {
    //     e.error = true;
    //   } else {
    //     e.error = false;
    //   }
    // }
    // else if (e.type && e.type !== 'string'){
    //   if (e.value === 0) {
    //     e.error = true;
    //   } else {
    //     e.error = false;
    //   }
    // }
    // e.edit = true;
  }

  addRow(): void {
    this.listOfData = [...this.listOfData, this.initRow()];
    this.tableConfig.tableData = this.listOfData;
  }

  initRow(e?: object) {
    const editorData = {};
    const columns = this.columns;
    columns.forEach((item, index) => {
      const temp = {
        name: item.name,
        type: 'string',
        value: e ? e[item.name] : null,
        edit: true,
        error: false,
        others: null,
        isSort: false,
        isLeft: false,
        isRight: false,
        // isTemplete: true
      };
      const tempAttrs = JSON.parse(JSON.stringify(item.attrs));
      temp.type = tempAttrs.type;
      setTimeout(() => {
        temp.isSort = e ? false : tempAttrs.isSort;
        temp.isLeft = e ? false : tempAttrs.isLeft;
        temp.isRight = e ? false : tempAttrs.isRight;
      });
      if (!item.others && !e) {
        if (!tempAttrs.type || tempAttrs.type === 'string') {
          temp.type = 'string';
        }
        if (tempAttrs.type === 'float') {
          temp.type = 'float';
          temp.value = temp.value || 0.0;
        }
      }
      if (item.others) {
        const tempOthers = JSON.parse(JSON.stringify(item.others));
        if (tempOthers.type === 'select') {
          tempOthers.defaultLoad = true;
          if (e) {
          }
          Object.defineProperty(tempOthers, 'width', { value: '100%', enumerable: true });
        } else if (tempOthers.type === 'year' || tempOthers.type === 'date') {
          if (e) {
            tempOthers.value = temp.value;
            // if (tempOthers.type === 'year') {
            //   const yearDateIndex = temp.value.indexOf('年');
            //   if (yearDateIndex && yearDateIndex !== -1) {
            //     temp.value.substring(yearDateIndex, 1);
            //   }
            // }
          }
          Object.defineProperty(tempOthers, 'width', { value: '100%', enumerable: true });
        } else if (tempOthers.type === 'checkBox') {
          temp.type = 'boolean';
          temp.value = temp.value === 'true' ? true : false;
        }
        temp.others = tempOthers;
      }
      editorData[temp.name] = temp;
    });
    return editorData;
  }

  showDeleteModal(obj: { event?: Event, config?: any, cellIndex?: number, rowData?: any, type?: string, data?: any }) {
    const { event, cellIndex, config, rowData, type, data } = obj;
    if (event) {
      event.stopPropagation();
    }
    if (type && type === 'batchDelete') {
      let checkedArr = [];
      checkedArr = this.pageRecords.filter((m) => m && m.checked && m.checked !== undefined);
      if (checkedArr.length) {
        const ids = checkedArr.map((d) => d[config.key]);
        this.modal.confirm({
          nzTitle: '提示',
          nzContent: '<b style="color: red;">确定要删除选中数据吗？</b>',
          nzOkText: '确定',
          nzOkType: 'danger',
          nzOnOk: () => this.deleteByHttp(config, ids),
          nzCancelText: '取消',
        });
      } else {
        this.message.error('请选择要删除的数据');
      }
    } else {
      this.modal.confirm({
        nzTitle: '提示',
        nzContent: '<b style="color: red;">确定要删除选中数据吗？</b>',
        nzOkText: '确定',
        nzOkType: 'danger',
        nzOnOk: () => this.removeCell(cellIndex, data),
        nzCancelText: '取消',
      });
    }
    // if (cellIndex !== undefined || rowData !== undefined) {
    //   this.modal.confirm({
    //     nzTitle: '提示',
    //     nzContent: '<b style="color: red;">确定要删除选中数据吗？</b>',
    //     nzOkText: '确定',
    //     nzOkType: 'danger',
    //     nzOnOk: () => type && type === 'batchDelete' ? this.deleteByHttp(config, rowData[config['key']]) : this.removeCell(cellIndex),
    //     nzCancelText: '取消',
    //   });
    // } else if (type && type === 'batchDelete') {
    // let checkedArr = [];
    // checkedArr = this.pageRecords.filter((m) => m && m.checked && m.checked !== undefined);
    // if (checkedArr.length) {
    //   const ids = checkedArr.map((d) => d[config['key']]);
    //   this.modal.confirm({
    //     nzTitle: '提示',
    //     nzContent: '<b style="color: red;">确定要删除选中数据吗？</b>',
    //     nzOkText: '确定',
    //     nzOkType: 'danger',
    //     nzOnOk: () => this.deleteByHttp(config, ids),
    //     nzCancelText: '取消',
    //   });
    // } else {
    //   this.message.error('请选择要删除的数据');
    // }
    // }
  }
  // 根据id删除表格数据
  deleteByHttp(config, id) {
    const params = {};
    Object.defineProperty(params, config.key, { value: id, enumerable: true });
    this.httpService.httpDelete(config.url, params).subscribe(res => {
      if (res.code === 1) {
        this.message.success('删除成功');
        this.getDynamicTableData();
        this.changeDetectorRef.detectChanges();
      }
    });
  }



  // 删除行
  removeCell(cellIndex: number, data) {
    this.listOfData = this.listOfData.filter(d => d.propertyName.value !== data.propertyName.value);
    this.tableConfig.tableData = this.listOfData;
    this.changeDetectorRef.detectChanges();

    // this.listOfData.splice(cellIndex, 1);
    // this.listOfData = [...this.listOfData];
  }

  // 导入
  importData(config) {
  }
  // 导出
  exportOptionChange(e) {
    const exportType = e.value;
    switch (exportType) {
      case 'checkedRows':
        this.exportCheckData(e, '报表');
        break;
      case 'checkedAllRow':
        this.openCheckGroup(e);
        break;
      case 'checkedCodes':
        this.exportCheckData(e, '二维码');
        break;
      case 'checkedAllCodes':
        this.openCheckGroup(e);
        break;
      default:
        break;
    }

  }

  exportCheckData(data, type) {
    if (!Object.keys(this.checkObj).length) {
      this.message.error(`请勾选要导出的${type}`);
      return;
    } else {
      const result = Object.values(this.checkObj);
      const someIsChecked = result.some((s) => s === true);
      someIsChecked ? this.openCheckGroup(data, this.checkObj) : this.message.error(`请勾选要导出的${type}`);
    }
  }

  openCheckGroup(data, tagChecked?) {
    let tagData = {};
    if (tagChecked) {
      tagData = tagChecked;
    }
    const config = {
      url: this.tableConfig.queryTitle, params: this.tableConfig.titleParams,
      exportUrl: data.url, tagData, modal: null, type: ''
    };
    let title = '导出报表';
    config.type = 'excel';
    if (data.value === 'checkedCodes' || data.value === 'checkedAllCodes') {
      title = '导出二维码';
      config.type = 'code';
      this.exportCode(data);
    }
    if (config.type === 'excel') {
      const dialogObj = {
        type: 'drawer',
        title,
        content: SCheckboxGroupComponent,
        params: { config }
      };
      const d = this.commonService.createModal(dialogObj);
      config.modal = d;
    }
  }

  exportCode(data) {
    let params: any;
    const ids = [];

    /**
     * 导出数据时默认checkKey为 id
     */
    if (data.value === 'checkedCodes') {
      for (const key in this.checkObj) {
        if (this.checkObj[key]) {
          ids.push(key);
        }
      }
      params = ids.join(',');
      if (ids.length > 1) {
        this.commonService.downLoad(data.url + 's', 'POST', params);
      } else {
        const requestUrl = `${data.url}/${params}`;
        this.commonService.downLoad(requestUrl, 'GET');
      }
    } else {
      params = '';
      this.commonService.downLoad(data.url, 'POST', params);
    }
  }

  getDate(obj, e) {
    obj.value = e;
    //
  }
  selectChange(obj, e) {
    obj.value = e.value;
  }

  checkedChange(obj, e) {
    obj.value = e;
  }

  // 列搜索输入删除事件
  upBack(e, item) {
    // if (e.keyCode === 8) {
    //   this.searchClick(item);
    // }
  }
  // 列搜索输入框点击搜索按钮
  searchClick(item) {
    // console.log(this.columns.filter(i => i.searchItem).map(i => i.searchItem).map(i => ({value: i.config.value, name: i.name})));
    if (item.config.value !== '') {
      this.tableConfig.tableParams[item.name] = item.config.value;
    } else {
      if (this.tableConfig.tableParams[item.name]) {
        delete this.tableConfig.tableParams[item.name];
      }
    }
    this.pageData.page = 1;
    this.getDynamicTableData();
  }

  // 列搜索日期范围选择
  rangeDateChange(e, item) {
    if (e.startDate) {
      this.tableConfig.tableParams[item.searchItem.config.keys.start] = e.startDate;
    } else {
      if (this.tableConfig.tableParams[item.searchItem.config.keys.start]) {
        delete this.tableConfig.tableParams[item.searchItem.config.keys.start];
      }
    }
    if (e.endDate) {
      this.tableConfig.tableParams[item.searchItem.config.keys.end] = e.endDate;
    } else {
      if (this.tableConfig.tableParams[item.searchItem.config.keys.end]) {
        delete this.tableConfig.tableParams[item.searchItem.config.keys.end];
      }
    }
    if ((e.startDate && e.endDate) || (!e.startDate && !e.endDate)) {
      this.pageData.page = 1;
      this.getDynamicTableData();
    }
  }

  // 列搜索日期选择
  dateChange(e, item) {
    if (e) {
      this.tableConfig.tableParams[item.name] = e;
    } else {
      if (this.tableConfig.tableParams[item.name]) {
        delete this.tableConfig.tableParams[item.name];
      }
    }
    this.pageData.page = 1;
    this.getDynamicTableData();
  }


  // 列搜索下拉选择
  selectModelChange(e, item) {
    if (item.config.mode === 'default' || !item.config.mode) {
      if (e === null || e === undefined) {
        const data = this.tableConfig.tableParams[item.name];
        if (data !== null || data !== undefined) {
          delete this.tableConfig.tableParams[item.name];
        }
      }
      if (e) {
        this.tableConfig.tableParams[item.name] = e.value;
      }
    } else {
      const value = e.map((d) => d.value);
      if (!e.length) {
        const data = this.tableConfig.tableParams[item.name];
        if (data !== null || data !== undefined) {
          delete this.tableConfig.tableParams[item.name];
        }
      }
      if (value.length) {
        this.tableConfig.tableParams[item.name] = value;
      }
    }
    this.pageData.page = 1;
    this.getDynamicTableData();
  }

  treeChange(e, item) {
    if (e) {
      this.tableConfig.tableParams[item.name] = e.value || '';
      this.pageData.page = 1;
      this.getDynamicTableData();
    }
  }
  yearChange(e, item) {
    if (e) {
      this.tableConfig.tableParams[item.name] = e;
    } else {
      if (this.tableConfig.tableParams[item.name]) {
        delete this.tableConfig.tableParams[item.name];
      }
    }
    this.pageData.page = 1;
    this.getDynamicTableData();
  }
  reload() {
    const params: any = { order: 'creationTime desc' };
    if (this.tableConfig.isPage) {
      params.pageSize = this.pageData.pageSie;
      params.page = this.pageData.page;
    }
    this.params = params;
    // this.tableConfig.tableParams = {};
    if (this.tableConfig.queryTitle) {
      this.getDynamicHeaders();
    } else if (this.tableConfig.queryTable) {
      this.getDynamicTableData();
    }
    this.setScrollY();
  }
}
